
import Utils from '@utils/utils';
import { useImperativeHandle, forwardRef, useContext, useState, useRef, useMemo, useEffect } from "react"
import { AppContext } from "@utils/AppContext"
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss'
import { Button, Input, message } from 'antd';
import { ExclamationCircleOutlined, VerifiedOutlined } from '@ant-design/icons';
import API, { commonApiInvoker } from "@api/api"
import eventBus from "@utils/eventBus"


const CompleteSeiviceInfoModal = forwardRef((props, ref) => {
    const {
        globalUser,
    } = useContext(AppContext)

    const [open, setOpen] = useState(false)
    const [mobile, setMobile] = useState()
    const [company, setCompany] = useState()
    const [isMobileError, setIsMobileError] = useState(false)
    const [verifyCode, setVerifyCode] = useState()
    const [waitCode, setWaitCode] = useState(false)
    const [countdown, setCountdown] = useState(60)
    const countdownRef = useRef(60)
    const [intervalId, setIntervalId] = useState()
    const [loading, setLoading] = useState(false)
    const [callback, setCallback] = useState(null);


    useImperativeHandle(ref, () => ({
        handleClick
    }))

    useEffect(() => {
        return () => {
            intervalId && clearInterval(intervalId)
        }
    }, [])

    const handleClick = (callback) => {
        setCallback(() => callback);
        const status = Utils.checkLoginStatus(() => loginAfter(callback))
        if (status) loginAfter(callback)
    }

    const loginAfter = (callback) => {
         API.userInfo({}).then((res) => {
            if(res.code == 0) {
                if(!res.data?.mobile || !res.data?.company) {
                    setOpen(true)
                } else {
                    callback()
                }
            }
        })

    }

    const onOk = () => {
        commonApiInvoker(API.bindMobileOrCompany({
            mobile: mobile,
            verifyCode: verifyCode,
            platform: 'psai',
            companyName: company?.trim(),
        }), setLoading, false).then(res => {
            callback()
            eventBus.emit('updatePower')
            eventBus.emit('updateUserInfo')
            setOpen(false)
        })
    }

    const mobileBlur = () => {
        setIsMobileError(!Utils.validateContact(mobile))
    }

    const codeClick = () => {
        mobileBlur()
        if (!Utils.validateContact(mobile)) return
        if (!waitCode) {
            setWaitCode(true)
            API.userSendCode({
                mobile: mobile
            }).then((res) => {
                if (res.code == 0) {
                    message.success('发送成功！')
                    let id = setInterval(() => {
                        countdownRef.current -= 1
                        setCountdown(countdownRef.current)
                        if (countdownRef.current === 0) {
                            clearInterval(id)
                            setWaitCode(false)
                            countdownRef.current = 60
                        }
                    }, 1000)
                    setIntervalId(id)
                } else {
                    setWaitCode(false)
                    message.error(res.message)
                }
            })
        }
    }

    const isTrueConfirm = useMemo(() => {
        if (!globalUser?.mobile && !globalUser?.company) {
            return mobile && verifyCode && company?.trim()
        } else {
            return company?.trim()
        }
    })


    return (
        <>
            <PSAIModal
                title={'完善信息'}
                maxWidth={520}
                okText={'确定'}
                open={open}
                maskClosable={false}
                okButtonProps={{ disabled: !isTrueConfirm, loading: loading }}
                onCancel={() => setOpen(false)}
                onOk={onOk}
            >
                <div className={styles.mobileModal_body}>
                    <div className={styles.mobileModal_form}>
                        {
                            !globalUser?.mobile && <>
                                <div className={styles.mobileModal_mobile}>
                                    <label htmlFor="mobile-new" className={styles.mobileModal_new_label}>绑定手机号</label>
                                    <Input
                                        id='mobile-new'
                                        className={styles.mobileModal_new_input}
                                        size='large'
                                        value={mobile}
                                        placeholder="请输入需要绑定的手机号"
                                        onBlur={mobileBlur}
                                        onChange={(e) => setMobile(e.target.value)}
                                        prefix={<img style={{ width: 16 }} src={require('@assets/images/icon_phone.png')} alt="" />}
                                    />
                                </div>
                                <div className={styles.mobileModal_code}>
                                    <label htmlFor="mobile-code" className={styles.mobileModal_code_label}>手机验证码</label>
                                    <Input
                                        id='mobile-code'
                                        size='large'
                                        maxLength={6}
                                        value={verifyCode}
                                        placeholder="请输入验证码"
                                        onChange={(e) => setVerifyCode(e.target.value)}
                                        prefix={<img style={{ width: 16 }} src={require('@assets/images/icon_Validation.png')} alt="" />}
                                    />
                                    <Button size='large' onClick={codeClick}>{waitCode ? `${countdown}秒` : '验证码'}</Button>
                                </div>
                            </>
                        }
                        {
                            !globalUser?.company && <div className={styles.mobileModal_mobile} style={{ marginBottom: 0 }}>
                                <label htmlFor="mobile-new" className={styles.mobileModal_new_label}>绑定公司名</label>
                                <Input
                                    id='mobile-company'
                                    className={styles.mobileModal_new_input}
                                    size='large'
                                    value={company}
                                    placeholder="请输入公司名"
                                    onChange={(e) => setCompany(e.target.value)}
                                    prefix={<VerifiedOutlined style={{ color: 'rgb(195 193 193)', fontSize: '18px' }} />}
                                />
                            </div>
                        }


                        <p className={styles.err_text} style={{ opacity: isMobileError ? 1 : 0 }}><ExclamationCircleOutlined /> 您输入的手机号错误</p>
                    </div>

                </div>
            </PSAIModal>
        </>
    )
})

export default CompleteSeiviceInfoModal